import { render } from "./PersonaForm.vue?vue&type=template&id=97f0cad8&scoped=true"
import script from "./PersonaForm.vue?vue&type=script&lang=js"
export * from "./PersonaForm.vue?vue&type=script&lang=js"

import "./PersonaForm.vue?vue&type=style&index=0&id=97f0cad8&scoped=true&lang=css"
import "@/assets/css/alertas.css?vue&type=style&index=1&id=97f0cad8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f0cad8"]])

export default __exports__